import QuestionHeader from "../component/QuestionHeader";
import QuestionFooter from "../component/QuestionFooter";
import {useEffect, useState} from "react";
import TextareaAutosize from 'react-textarea-autosize';
import {useParams} from "react-router-dom";
import {useQuestion} from "../../../../redux/Reducers/QuestionReducer";
import useForm from "../../../../hooks/useForm";
import URLS from "../../../../API/Axios/URLS";
import FormNoneFieldErrors from "../../../../components/Form/FormNoneFieldErrors";
import AnswerDropDown from "../component/AnswerDropDown";
import GenericQuestionModal from "../Modal/GenericQuestionModal/GenricQuestionModal";
import {tokenizeSentence} from "../../../../utils/utils";


export default function WritingSample({className, ...props}) {
    const {question, questionActions} = useQuestion()
    const [showModal, setShowModal] = useState(false)
    const {id} = useParams()
    const [form, error, loading, setFormData, actions] = useForm({
        questionId: id,
        answer: "",
        time: 0
    })
    const [response, setResponse] = useState({})

    function submitAnswer() {
        let minWords = 50;
        // to integer
        minWords = Math.floor(minWords)
        if (tokenizeSentence(form?.answer).length < minWords) {
            actions.setError({
                non_field_errors: [`Answer should be at least ${minWords} words`]
            })
            return
        }
        actions.post(URLS.genericQuestionView, (data) => {
            let totalTimeInSec = (Date.now() - data.time) / 1000
            // remove decimal points
            totalTimeInSec = Math.floor(totalTimeInSec)

            return {
                ...data,
                time: totalTimeInSec
            }
        }).then(response => {
            setResponse(response?.data)
            setShowModal(true)
            setFormData({
                time: 0
            })
        })

    }


    useEffect(() => {
        questionActions.loadQuestions(id)
    }, [id])



    return (
        <div className={`rounded-lg shadow-lg p-4 ${className}`}>
            <QuestionHeader  {...question}
                             timeLimit={question?.timeLimit && question?.timeLimit + 30000}

            />
            <GenericQuestionModal
                result={response}
                showModal={showModal} setShowModal={setShowModal}/>
            <div className={" flex flex-col items-center md:flex-row p-2 py-8 justify-center gap-8"}>

                <div className={"flex flex-1 px-8 flex-col gap-4"}>
                    <p className={"text-lg font-semibold"}>{question?.text}</p>
                    <TextareaAutosize
                        minRows={10}
                        placeholder="Write your answer here"
                        value={form?.answer}
                        onChange={(e) => {
                            if (form.time === 0) {
                                form.time = Date.now()
                            }
                            setFormData({
                                answer: e.target.value
                            })
                        }}

                        className="w-full rounded-lg border-[1.5px] text-black-2 dark:text-white border-b-graydark bg-white py-2 px-2 font-medium outline-none transition focus:border-primary active:border-primary disabled:cursor-default disabled:bg-whiter dark:border-form-strokedark dark:bg-form-input dark:focus:border-primary"
                    ></TextareaAutosize>
                    <FormNoneFieldErrors errors={error?.answer || error?.non_field_errors}/>
                    <div className={"flex w-full flex-row-reverse"}>
                        Word Count : {form?.answer.trim().length !== 0 ? form?.answer.trim().split(" ").length : "0"}
                    </div>
                </div>


            </div>
            <QuestionFooter className={"mx-4 my-2"}
                            loading={loading}
                            onClickSubmit={submitAnswer}

            />

            <AnswerDropDown
                className={" mt-4 "}
                headerTitle={"Show Answer"}
                allowEditing={true}
                justifications={question?.answerText}
            />

        </div>

    )


}
